import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import FaView from '../FaView';
import CancelDialog from '../CancelDialog';
import Tran_data_unlock_request from '../Tran_data_unlock_request';

function Tran_tt_settlement() {


    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const currentDate = new Date();

    const [isTtSalesSettl, setIsTtSalesSettl] = useState("SALES");
    const [key, setKey] = useState("INFO");
    const [settTabKey, setSettTabKey] = useState('PRODUCTDETAIL');
    // const [settkey, setSettKey] = useState("INFO");


    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");

    const [dataList, setDataList] = useState([]);
    const [productData, setProductData] = useState([]);
    const [salesProductData, setSalesProductData] = useState([]);
    const [settlementProductData, setSettlementProductData] = useState([]);

    const [paymentData, setPaymentData] = useState([]);
    const [radioType, setRadioType] = useState("S");
    const [ttSettlementLocation, setTtSettlementLocation] = useState(null);
    const [locationCode, setLocationCode] = useState('0');
    const [location, setLocation] = useState("");
    const [ttFromSrno, setVtmFromSrno] = useState("");
    const [ttToSrno, setVtmToSrno] = useState("");
    const [vtmFromDate, setVtmFromDate] = useState(new Date());
    const [ttToDate, setVtmToDate] = useState(new Date());
    const [ledger, setLedger] = useState("");
    const [date, setDate] = useState(new Date());
    const [total, setTotal] = useState("");
    const [forexTotal, setForexTotal] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [faViewData, setFaViewData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrType, setHdrType] = useState("");
    const [hdrLocation, setHdrLocation] = useState("");
    const [hdrIndivisual, setHdrIndivisual] = useState("");
    const [showFaView, setShowFaView] = useState(false);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [a2FormRight, setA2FormRight] = useState([]);

    const [settleHdrSrno, setSettleHdrSrno] = useState("0");
    const [salesPayment, setSalesPayment] = useState([]);
    const [settlementPayment, setSettlementPayment] = useState([]);
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [cancelButtonView, setCancelButtonView] = useState(true);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setTtSettlementLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'SALES_ADII'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            // A2 Form Right ===========================
            Common.callApi(Common.apiRight, [sid, 'all', 'A2_FORM'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setA2FormRight(resp);
                }
            });

            // Cancel Bill Right ===========================
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserCancelBillRight(resp);
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setTtSettlementLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
        setDataList([])
    }


    const listData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (ttSettlementLocation === null) {
            $(".loader").hide();
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else if ((radioType === 'S' && !ttFromSrno) || (radioType === 'S' && !ttToSrno) || (radioType === 'D' && !vtmFromDate) || (radioType === 'D' && !ttToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (radioType === 'S' && !ttFromSrno ? " From." : '');
            msg[i++] = (radioType === 'S' && !ttToSrno ? " To." : '');
            msg[i++] = (radioType === 'D' && !vtmFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !ttToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                locationCode: locationCode,
                filterRadioType: radioType,
                filterFromSrno: ttFromSrno,
                filterToSrno: ttToSrno,
                filterFromDate: Common.dateYMD(vtmFromDate),
                filterToDate: Common.dateYMD(ttToDate),
                type: "TT"
            }
            Common.callApi(Common.apiTtSettlement, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.status) {
                    setDataList(resp.list);
                } else {
                    setMsgBoxYN(true);
                    setScrMode(resp.msg);
                }
            });
        }
    }


    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }


    function viewList(res) {
        $(".loader").show();
        setScrMode('Q');
        // setLocation(locationName);
        // setLedger(ledger);
        // setTotal(res.hdr_total);
        setDate(res.hdr_date);
        setHdrType(res.hdr_type);
        setHdrSrno(res.hdr_srno);
        setHdrLocation(res.hdr_location);
        setTotalAmount(Math.round(res.forex_amount))
        setForexTotal(Math.round(res.hdr_forex_total))
        setIsTtSalesSettl('SALES');
        setKey("INFO");
        setSettTabKey('PRODUCTDETAIL');
        const obj = {
            srno: res.hdr_srno,
            // line_no:res.
            location: res.hdr_location,
            type: 'TT',
        }
        Common.callApi(Common.apiTtSettlement, [sid, 'view', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setSalesProductData(resp.productSalesArray);
            setSettlementProductData(resp.productSattelementArray);
            setProductData(resp.productSalesArray);
            setPaymentData(resp.paymentData);
            setHdrIndivisual(resp.productSalesArray[0]?.hdr_individual)
            setSettleHdrSrno(resp.productSalesArray[0].settsrno);
            setSettlementPayment(resp.settlementPaymentDetais);
            setSalesPayment(resp.salePaymentDetais);
            setCancelButtonView(resp.productSalesArray[0]?.hdr_cancel_billYN === "1" ? false : true);

            // resp.paymentData.map(data=>)
            // setTotal(resp.paymentData[0].tp_amount);
        });
    }


    const handleFaView = (hdrSrno, hdrType) => {
        setShowFaView(true);
        setFaViewObject({ location: hdrLocation, trannumber: hdrSrno, type: hdrType });
    }

    function handlePrint() {
        $(".loader").show();
        const obj = {
            pType: 'TT',
            type: hdrType,
            location: hdrLocation,
            srno: hdrSrno,
            printFlag: 'D',
            nCorporate: null,
        }
        Common.callApi(Common.apiPrint, [sid, 'print', JSON.stringify(obj)], (result) => {
            if (result) {
                $(".loader").hide();
                var newWindow = window.open();
                newWindow.document.write(result);
            }
        })
    }

    const handleTabChange = (k) => {
        setKey(k);
        // if (k === "PAYMENT") {
        //     setPdAccount(null);
        //     setPdPaymentType("");
        //     const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
        //     setPdAmount(1 * pTotalAmount - amt);
        // }
    }
    const printHandler = () => {
        $(".loader").show();
        let msg = [];
        msg.push(Common.getMessage("MSG0006"));
        !hdrIndivisual && msg.push("Individual is not Present");
        if (msg.length > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                nIndivualSrno: hdrIndivisual,
                type: 'SP',
                location: hdrLocation,
                srno: hdrSrno,
            }
            Common.callApi(Common.apiPrint, [sid, "tcs_eligibility_print", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                var newWindow = window.open();
                newWindow.document.write(resp);
            });
        }
    }

    const setIsTtSalesSettlHandler = (key) => {
        setIsTtSalesSettl(key);
        if (key == 'SALES') {
            setProductData(salesProductData);
        } else {
            setProductData(settlementProductData);
        }
    }

    const handleA2FormView = (id, location, a2Type) => {
        // console.log("Header Serial No. is : ", id);
        const url = `/a2-form/${id}/${location}/${a2Type}`;
        const newTab = window.open(url, "_blank");
        if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
            navigate(url);
        }
    }
    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = date.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'TT',
            pageright: 'SALES_ADII',
            location: hdrLocation
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'TT', trannumber: hdrSrno, location: hdrLocation, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'TT',
            location: hdrLocation,
            srno: hdrSrno,
            productList: productData,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listData();
                setMsgText(resp.msg);
                setMsgBox(true);
                expireUnlock();
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }
    const expireUnlock = () => {
        if (scrMode == 'E' && unlockRequestType !== "SELF") {
            const obj = {
                srno: hdrSrno,
                type: 'TT',
                status: 'E',
                currentDate: Common.dateYMD(currentDate),
                pageright: 'SALES_ADII'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }

    }   
    const handleNextBill = () => {
             const obj = {
               location: hdrLocation,
               type:  'SP',
               srno: hdrSrno,   
               hdr_tran_source: "EREMIT",
               prd_product: ['TT', 'DD'] 

           };
           console.log('TT object',obj);
           Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
                const resp = JSON.parse(result);
                console.log(resp);
                   if (resp.srno && resp.type) {
                    viewList({
                        hdr_srno: resp.srno,
                        hdr_location: resp.location || hdrLocation,
                        hdr_type: 'OT',
                    });
                    console.log(viewList);
                   } else {
                       setMsgText("No next bill available.");
                       setMsgBox(true);
                   }
           });
    }
    
    const handlePrevBill = () => {
                  const obj = {
                      location: hdrLocation,
                      type:  'SP',
                      srno: hdrSrno,
                      hdr_tran_source:"EREMIT",
                      prd_product: ['TT', 'DD'] 
                  };
                  Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
                      const resp = JSON.parse(result);
                      console.log(resp);
                      if (resp.srno) {
                         viewList({
                        hdr_srno: resp.srno,
                        hdr_location: resp.location || hdrLocation,
                        hdr_type: resp.hdr_type,
                      });
                      } else {
                          setMsgText("No previous bill available.");
                          setMsgBox(true);
                      }
                      });
    }

        const handleUserView = (hdrSrno, hdrLocation, type) => {
            $(".loader").show();
            const obj = {
                hdr_srno: hdrSrno,
                location: hdrLocation,
                type: "SP"
            };

            Common.callApi(Common.apiCommom, [sid, "checkIrn", JSON.stringify(obj)], result => {
                $(".loader").hide();
                const resp = JSON.parse(result);

                if (resp.status !== "MSG0000") {
                    setMsgText("Bill not found.");
                    setMsgBox(true);
                    return;
                }

                const head = resp.isIrnEditable === "1" ? "Irn is not generated." : "Irn is generated.";
                const rows = resp.knockoffList || [];

                setMsgText(
                    <div>
                        <div>{head}</div>
                        {rows.length === 0
                            ? <div>No knockoff records found.</div>
                            : rows.map((r, i) => (
                                <div key={i}>
                                    KnockOffSrno: {r.tfd_srno}, Location: {r.tfd_location}, Date: {r.tfd_date}
                                </div>
                            ))}
                    </div>
                );
                setMsgBox(true);
            });
        };
     




    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>AD II </h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ttSettlementLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === 'S' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={ttFromSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setVtmFromSrno)}
                                                        placeholder="From" />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={ttToSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setVtmToSrno)}
                                                        placeholder="To" />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        radioType === 'D' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={vtmFromDate}
                                                            onChange={(date) => setVtmFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={ttToDate}
                                                            onChange={(date) => setVtmToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => listData()}>List</Button>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th>Sr No</th>
                                                <th>Location</th>
                                                <th>Ledger</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Ref no</th>
                                                <th>Remitter Name</th>
                                                <th>Pan No</th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataList.map((res, index) => (
                                                    <tr key={index}>
                                                        {userRight.query === "1" ?
                                                            <td className="textCenter">
                                                                <span className="handCursor colorThemeBlue" onClick={() => viewList(res)}>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                            </td>
                                                            : null
                                                        }
                                                        <td>{res.hdr_srno}</td>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                        <td>{res.hdr_date}</td>
                                                        <td>{res.hdr_forex_total}</td>
                                                        <td>{res.hdr_refno}</td>
                                                        <td>{res.hdr_remittername}</td>
                                                        <td>{res.hdr_pan}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelData()}>Back</Button> {' '}

                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1" && cancelButtonView) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                       {
                                                    (scrMode === "Q" && +userRight.query === 1 ) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.query === 1 ) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                                    </>
                                                }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>

                            <Tabs activeKey={isTtSalesSettl} defaultActiveKey="SALES" onSelect={k => setIsTtSalesSettlHandler(k)}>
                                <Tab eventKey="SALES" title="Sales">
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaView(hdrSrno, 'SP')}>FA View</Button>&nbsp;
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handlePrint()}>Print</Button>&nbsp;
                                            {hdrIndivisual && <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={printHandler}>Tcs Annexure</Button>}&nbsp;
                                            {a2FormRight.query === "1" ?
                                                <>
                                                    <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleA2FormView(hdrSrno, locationCode, 'TT')}>A2 Form 1</Button>&nbsp;
                                                </> : null
                                            }
                                            {userRight.query === "1" ?
                                                <>
                                                    <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleUserView(hdrSrno, locationCode, 'TT')}>Irn editable</Button>&nbsp;
                                                </> : null
                                            }
                                        </Col>
                                    </Row>

                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col >
                                            <Form.Label><b>Srno:</b> {salesProductData[0]?.hdr_srno}</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Label><b>Location:</b> {location}</Form.Label>
                                        </Col>
                                        <Col>
                                            <Form.Label><b>Date:</b> {date}</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Label><b>Forex Amount: </b>{salesProductData[0]?.hdr_forex_total}</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Label><b>Total Amount:</b> {salesProductData[0]?.hdr_total_inr}</Form.Label>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col style={{ justifyContent: 'space-evenly' }}>
                                            <span> <b>Texable Value : </b>{salesProductData[0]?.hdr_taxable_value}</span>
                                            <span> <b>GST : </b>{salesProductData[0]?.hdr_gst}</span>
                                            <span> <b>SGST : </b>{salesProductData[0]?.hdr_sgst}</span>
                                            <span> <b>IGST : </b>{salesProductData[0]?.hdr_igst}</span>
                                            <span> <b>CGST : </b>{salesProductData[0]?.hdr_cgst}</span>
                                            <span> <b>UGST : </b>{salesProductData[0]?.hdr_ugst}</span>
                                            <span> <b>TCS : </b>{salesProductData[0]?.hdr_tcs}</span>
                                            <span> <b>Round Off : </b>{salesProductData[0]?.hdr_roundoff}</span>
                                            <span> <b>Bank Charges : </b>{salesProductData[0]?.hdr_bankcharges}</span>
                                            <span><b>Nostro Charges : </b>{salesProductData[0]?.hdr_nostrocharges}</span>

                                            <br></br>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                        <Tab eventKey="INFO" title="All Info">
                                            <Row>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Ref No : {salesProductData[0]?.hdr_refno}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Individual : {salesProductData[0]?.individual_name}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Individual Id : {salesProductData[0]?.indi_idtype_num}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Executive : {salesProductData[0]?.executive_name}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>IBan Number : {productData[0]?.hdr_iban_no}</Form.Label>
                                                    </Form.Group>
                                                </Col> */}
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Pan Number : {salesProductData[0]?.hdr_pan}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Name On Pan : {salesProductData[0]?.hdr_nameonpan}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Nostro Type : {salesProductData[0]?.hdr_nostrotype}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Pan Relation : {productData[0]?.hdr_pan_relation}</Form.Label>
                                                    </Form.Group>
                                                </Col> */}
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Purpose : {salesProductData[0]?.purpose_name}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Remitter Name : {productData[0]?.hdr_remittername}</Form.Label>
                                            </Form.Group>
                                        </Col> */}
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Place of Supply : {salesProductData[0]?.hdr_supply_place}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Source Of Fund : {productData[0]?.hdr_sourceoffund === 'L' ? 'Loan' : 'Other'}</Form.Label>
                                                    </Form.Group>
                                                </Col> */}
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Product Type : {salesProductData[0]?.prd_product}</Form.Label>
                                                    </Form.Group>
                                                </Col>

                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col>
                                                    <h4>Remmiter Details</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th>Date Of Birth</th>
                                                                <th>Id Type</th>
                                                                <th>Id No </th>
                                                                <th>Type</th>
                                                                <th>Address</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr key={0}>
                                                                <td>{salesProductData[0]?.hdr_remittername}</td>
                                                                <td>{Common.dateDMYStr(salesProductData[0]?.hdr_remitterdob)}</td>
                                                                <td>{salesProductData[0]?.remitteriddesc}</td>
                                                                <td>{salesProductData[0]?.hdr_remitteridno}</td>
                                                                <td>{salesProductData[0]?.hdr_remittertype === 'I' ? 'Individual' : salesProductData[0]?.hdr_remittertype}</td>
                                                                <td>{salesProductData[0]?.hdr_remitteraddress}</td>

                                                            </tr>

                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>

                                        </Tab>
                                        <Tab eventKey="BENE" title="Beneficiary Details">
                                            <Row>
                                                <Col>
                                                    <h4>Beneficiary Details</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th>Account Number</th>
                                                                <th>Bank</th>
                                                                <th>Swift Code</th>
                                                                <th>Type</th>
                                                                <th>Address</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr key={0}>
                                                                <td>{salesProductData[0]?.hdr_benename}</td>
                                                                <td>{salesProductData[0]?.hdr_benebankacct}</td>
                                                                <td>{salesProductData[0]?.hdr_benebank}</td>
                                                                <td>{salesProductData[0]?.hdr_beneswiftcode}</td>
                                                                <td>{salesProductData[0]?.hdr_bene_type}</td>
                                                                <td>{salesProductData[0]?.hdr_beneadd}</td>
                                                            </tr>

                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            {salesProductData[0]?.hdr_sourceoffund === 'L' && <>
                                                <Row>
                                                    <Col>
                                                        <h4>Loan Details</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Account Number</th>
                                                                    <th>Name</th>
                                                                    <th>Pan</th>
                                                                    <th>Passport</th>
                                                                    <th>Co Applicant Name</th>
                                                                    <th>Co Applicant Pan</th>
                                                                    <th>Co Applicant Passport</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr key={0}>
                                                                    <td>{salesProductData[0]?.hdr_loanaccountno}</td>
                                                                    <td>{salesProductData[0]?.hdr_loanapplicant}</td>
                                                                    <td>{salesProductData[0]?.hdr_loanapplicantpan}</td>
                                                                    <td>{salesProductData[0]?.hdr_loanapplicantpassport}</td>
                                                                    <td>{salesProductData[0]?.hdr_loancoapplicant}</td>
                                                                    <td>{salesProductData[0]?.hdr_loancoapplicantpan}</td>
                                                                    <td>{salesProductData[0]?.hdr_loancoapplicantpassport}</td>
                                                                </tr>

                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </>}
                                        </Tab>
                                        <Tab eventKey="PRODUCTDETAILS" title="Product Details">
                                            <Row>
                                                <Col>
                                                    <h4>Product Info</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Location</th>
                                                                <th>ISD</th>
                                                                <th>Ledger</th>
                                                                <th>Date</th>
                                                                <th>Product</th>
                                                                <th>Denomination</th>
                                                                <th>Quantity</th>
                                                                <th>Rate</th>
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                salesProductData.map((res, index) => (
                                                                    <tr key={index}>
                                                                        <td>{res.entity_name}</td>
                                                                        <td>{res.isd}</td>
                                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                        <td>{res.prd_date}</td>
                                                                        <td>{res.prd_product}</td>
                                                                        <td>{res.prd_deno}</td>
                                                                        <td>{res.prd_qty}</td>
                                                                        <td>{res.prd_rate}</td>
                                                                        <td>{res.prd_amount}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                        </Tab>
                                        <Tab eventKey="PAYMENTDETAILS" title="Payment Details">
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Location</th>
                                                                <th>Ledger</th>
                                                                <th>Payment Type</th>
                                                                <th>Amount</th>
                                                                <th>Ref</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                salesPayment.map((res) => (
                                                                    (res.tp_type === 'SP' && <tr key={res.tp_line_no}>
                                                                        <td>{res.entity_name}</td>
                                                                        {/* <td>{res.ledger}</td> */}
                                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                        <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                                            res.tp_payment_type === "PB" ? "Payables" :
                                                                                res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type}
                                                                        </td>
                                                                        <td>{res.tp_amount}</td>
                                                                        <td>{res.tp_cheque}</td>
                                                                    </tr>)
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        <Tab eventKey="COMMISSIONDETAILS" title="Commission Details">
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Agent</th>
                                                                <th>Commission Rs</th>
                                                                <th>Commission Type</th>
                                                                <th>Commission </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                salesProductData?.map((res, num) => (
                                                                    <tr key={num}>
                                                                        <td>{res.agent_name}</td>
                                                                        <td>{res.prd_commission_value}</td>
                                                                        <td>{res.prd_commission_type === 'F' ? 'FLAT' :
                                                                            res.prd_commission_type === 'R' ? 'PERCANTAGE' :
                                                                                res.prd_commission_type === 'P' ? 'PAISA' :
                                                                                    res.prd_commission_type}</td>

                                                                        <td>{res.prd_commission}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        {/* <Row>
                                            <Col>
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Location</th>
                                                            <th>Ledger</th>
                                                            <th>Payment Type</th>
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            salesPayment.map((res) => (
                                                                <tr key={res.tp_line_no}>
                                                                    <td>{res.entity_name}</td>
                                                                  
                                                                    <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                    <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                                        res.tp_payment_type === "PB" ? "Payables" :
                                                                            res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type}
                                                                    </td>
                                                                    <td>{res.tp_amount}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row> */}
                                    </Tabs>
                                </Tab>
                                <Tab eventKey="SETTLEMENT" title="Settlement">
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaView(settleHdrSrno, 'OT')}>FA View</Button>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col >
                                            <Form.Label><b>Srno:</b> {settlementProductData[0]?.hdr_srno}</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Label><b>Location:</b> {location}</Form.Label>
                                        </Col>
                                        <Col>
                                            <Form.Label><b>Date:</b> {date}</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Label><b>Forex Amount: </b>{settlementProductData[0]?.hdr_forex_total}</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Label><b>Total Amount:</b> {settlementProductData[0]?.hdr_total_inr}</Form.Label>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col style={{ justifyContent: 'space-evenly' }}>
                                            <span> <b>GST : </b>{settlementProductData[0]?.hdr_gst}</span>
                                            <span> <b>SGST : </b>{settlementProductData[0]?.hdr_sgst}</span>
                                            <span> <b>IGST : </b>{settlementProductData[0]?.hdr_igst}</span>
                                            <span> <b>CGST : </b>{settlementProductData[0]?.hdr_cgst}</span>
                                            <span> <b>UGST : </b>{settlementProductData[0]?.hdr_ugst}</span>
                                            <span> <b>TCS : </b>{settlementProductData[0]?.hdr_tcs}</span>
                                            <span> <b>Round Off : </b>{settlementProductData[0]?.hdr_roundoff}</span>
                                            <span> <b>Bank Charges : </b>{settlementProductData[0]?.hdr_bankcharges}</span>
                                            <span><b>Nostro Charges : </b>{settlementProductData[0]?.hdr_nostrocharges}</span>

                                            <br></br>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Tabs activeKey={settTabKey} defaultActiveKey="PRODUCTDETAIL" onSelect={k => setSettTabKey(k)}>
                                        <Tab eventKey="PRODUCTDETAIL" title="Product Details">
                                            <Row>
                                                <Col>
                                                    <h4>Product Info</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Location</th>
                                                                <th>ISD</th>
                                                                <th>Ledger</th>
                                                                <th>Date</th>
                                                                <th>Product</th>
                                                                <th>Denomination</th>
                                                                <th>Quantity</th>
                                                                <th>Rate</th>
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                settlementProductData.map((res, index) => (
                                                                    <tr key={index}>
                                                                        <td>{res.prd_location}</td>
                                                                        <td>{res.prd_isd}</td>
                                                                        {/* <td>{res.settledger}</td> */}
                                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                        <td>{res.prd_date}</td>
                                                                        <td>{res.prd_product}</td>
                                                                        <td>{res.prd_deno}</td>
                                                                        <td>{res.prd_qty}</td>
                                                                        <td>{res.prd_rate}</td>
                                                                        <td>{res.prd_amount}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                        </Tab>
                                        <Tab eventKey="PAYMENTDETAILS" title="Payment Details">
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Location</th>
                                                                <th>Ledger</th>
                                                                <th>Payment Type</th>
                                                                <th>Amount</th>
                                                                <th>Ref</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                settlementPayment.map((res) => (
                                                                    <tr key={res.tp_line_no}>
                                                                        <td>{res.entity_name}</td>
                                                                        {/* <td>{res.ledger}</td> */}
                                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                        <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                                            res.tp_payment_type === "PB" ? "Payables" :
                                                                                res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type}
                                                                        </td>
                                                                        <td>{res.tp_amount}</td>
                                                                        <td>{res.tp_cheque}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Tab>
                                    </Tabs >
                                </Tab>
                            </Tabs >

                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                    {msgTextYNBillDelete}
                </CancelDialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
            </div>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default Tran_tt_settlement
